export const Log = (log) => {
  if(process.env.REACT_APP_DEBUG){
    console.log('Debug')
    console.log(log)
  }
}